import { Accordion } from '@ui-component-library/components/Accordion';
import { Alert } from '@ui-component-library/components/Alert';
import { Button as BaseButton } from '@ui-component-library/components/Button';
import { Checkbox as BaseCheckbox } from '@ui-component-library/components/Checkbox';
import { Chip as BaseChip } from '@ui-component-library/components/Chip';
import { Dialog } from '@ui-component-library/components/Dialog';
import { Drawer } from '@ui-component-library/components/Drawer';
import { Dropdown as BaseDropdown } from '@ui-component-library/components/Dropdown';
import { FileUpload } from '@ui-component-library/components/FileUpload';
import { HelperText as BaseHelperText } from '@ui-component-library/components/HelperText';
import { Icon as BaseIcon } from '@ui-component-library/components/Icon';
import { Input as BaseInput } from '@ui-component-library/components/Input';
import { InputOTP as BaseInputOTP } from '@ui-component-library/components/InputOTP';
import { Link as BaseLink } from '@ui-component-library/components/Link';
import { List as BaseList } from '@ui-component-library/components/List';
import { Modal } from '@ui-component-library/components/Modal';
import { PaginationDots as BasePaginationDots } from '@ui-component-library/components/PaginationDots';
import { Popover as BasePopover } from '@ui-component-library/components/Popover';
import { Progressbar as BaseProgressbar } from '@ui-component-library/components/Progressbar';
import { RadioButton as BaseRadioButton } from '@ui-component-library/components/RadioButton';
import { SearchInput as BaseSearchInput } from '@ui-component-library/components/SearchInput';
import { Selector as BaseSelector } from '@ui-component-library/components/Selector';
import { Sheet } from '@ui-component-library/components/Sheet';
import {
  useSliderController as BaseUseSliderController,
  Slider
} from '@ui-component-library/components/Slider';
import { SliderBar } from '@ui-component-library/components/SliderBar';
import { Switch as BaseSwitch } from '@ui-component-library/components/Switch';
import { Table } from '@ui-component-library/components/Table';
import { Tabs as BaseTabs } from '@ui-component-library/components/Tabs';
import { Text as BaseText } from '@ui-component-library/components/Text';
import { Textarea as BaseTextarea } from '@ui-component-library/components/Textarea';
import { showToast, Toaster } from '@ui-component-library/components/Toast';
import { Tooltip as BaseTooltip } from '@ui-component-library/components/Tooltip';
import { withTailwindWrapper } from '@ui-component-library/utils/withTailwindWrapper';

import { BarsChart, LinesChart, PiesChart } from './components/Chart/lib';
import { Loader as BaseLoader } from './components/Loader';
import { Summary as BaseSummary } from './components/Summary';

/* Colors */
export { default as COLORS } from './styles/colors';

/* Charts */
export const BarChart = BarsChart;
export const LineChart = LinesChart;
export const PieChart = PiesChart;

/* Components */
export { Accordion, Dialog, Drawer, Modal, Sheet, Slider, SliderBar, Table, Toaster, showToast };
export { Alert as TwAlert, FileUpload as TwFileUpload };
export { TextVariants } from '@ui-component-library/components/Text';

export const Button = withTailwindWrapper(BaseButton);
export const Checkbox = withTailwindWrapper(BaseCheckbox);
export const Chip = withTailwindWrapper(BaseChip);
export const Dropdown = withTailwindWrapper(BaseDropdown);
export const HelperText = withTailwindWrapper(BaseHelperText);
export const Icon = withTailwindWrapper(BaseIcon);
export const Input = withTailwindWrapper(BaseInput);
export const InputOTP = withTailwindWrapper(BaseInputOTP);
export const Link = withTailwindWrapper(BaseLink);
export const List = withTailwindWrapper(BaseList);
export const Loader = withTailwindWrapper(BaseLoader);
export const PaginationDots = withTailwindWrapper(BasePaginationDots);
export const Popover = withTailwindWrapper(BasePopover);
export const Progressbar = withTailwindWrapper(BaseProgressbar);
export const RadioButton = withTailwindWrapper(BaseRadioButton);
export const SearchInput = withTailwindWrapper(BaseSearchInput);
export const Selector = withTailwindWrapper(BaseSelector);
export const Summary = withTailwindWrapper(BaseSummary);
export const Switch = withTailwindWrapper(BaseSwitch);
export const Tabs = withTailwindWrapper(BaseTabs);
export const Text = withTailwindWrapper(BaseText);
export const Textarea = withTailwindWrapper(BaseTextarea);
export const Tooltip = withTailwindWrapper(BaseTooltip);

/* Raw (unwrapped) exports for use without TailwindWrapper context */
export const TwButton = BaseButton;
export const TwDropdown = BaseDropdown;
export const TwModal = Modal;
export const TwSelector = BaseSelector;
export const TwTabs = BaseTabs;

/* Hooks */
export const useSliderController = BaseUseSliderController;
